import Vue from 'vue'
import Router from 'vue-router'

// 页面资源
// TODO 做成响应式 合并pc与mobile组件之间重复的代码
import Recruit from '@/views/Recruit/Recruit.vue'
import RecruitDetail from '@/views/RecruitDetail/RecruitDetail.vue'
import RecruitPost from '@/views/RecruitPost/RecruitPost.vue'
import RecruitApply from '@/views/RecruitApply/RecruitApply.vue'
import RecruitTempMore from '@/views/RecruitTempMore/RecruitTempMore.vue'
import RecruitTempDetail from '@/views/RecruitDetail/RecruitTempDetail.vue'
import RecruitTempPost from '@/views/RecruitPost/RecruitTempPost.vue'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};


let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'recruit',
      component: Recruit,
      meta: {
        notNeedAuth: true,
        keepAlive: true,
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: RecruitDetail
    },
    {
      path: '/post',
      name: 'post',
      component: RecruitPost
    },
    {
      path: '/apply',
      name: 'apply',
      component: RecruitApply,
      meta: {
        notNeedAuth: true,
        keepAlive: true,
      }
    },
    {
      path: '/tempMore',
      name: 'tempMore',
      component: RecruitTempMore,
      meta: {
        notNeedAuth: true,
        keepAlive: true,
      }
    },
    {
      path: '/tempDetail',
      name: 'tempDetail',
      component: RecruitTempDetail,
    },
    {
      path: '/tempPost',
      name: 'tempPost',
      component: RecruitTempPost
    },

    {
      path: '*',
      redirect: '/'
    },
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router